import IchiBalanceContainer from 'containers/IchiBalanceContainer';
import NetworkSelectorContainer from 'containers/NetworkSelectorContainer';
import React, { PropsWithChildren } from 'react';
import RightNav from '../common/components/RightNav/RightNav';
import IchiLogo from 'common/components/IchiLogo/IchiLogo';
import { Link } from 'gatsby';
import WalletContainer from 'common/components/Web3ModalContainer/WalletContainer';

type Props = {
  toggleTheme?: () => void;
};

const TopBarContainer: React.FC<Props & PropsWithChildren> = (props) => {
  return (
    <div className="flex flex-row justify-center styled-fixed-sidebar pt-8 pb-8 w-full">
      <div className="flex flex-row justify-between w-[1440px] max-w-full">
        <Link to="/">
          <IchiLogo className="w-28 mx-3" />
        </Link>
        <div className="flex flex-row justify-end items-center">
          <NetworkSelectorContainer />
          <div className="hidden tablet:flex items-center">
            <IchiBalanceContainer />
            <WalletContainer />
          </div>
          <RightNav toggleTheme={props.toggleTheme} />
        </div>
      </div>
    </div>
  );
};

export default TopBarContainer;
